module.exports = __webpack_public_path__ + "media/images/login-background-2-32b7bc5e4c174a0620ba3e7fcf2fee73.jpeg";